"use client";
import { useState, useEffect } from "react";
import axios from "axios";
import { FaRegFilePdf } from "react-icons/fa";

const OptionsModal = ({ isOpen, onClose, transport, onOpenPdfGatePassModal }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDocuments = async () => {
      if (!isOpen || !transport?.id) return;

      setLoading(true);
      setError("");
      try {
        const userToken = localStorage.getItem("token");
        const response = await axios.get(
          `https://new.cajuu.app/api/loadtransport/get_documents/${transport.id}`,
          {
            headers: {
              "Authorization": `Bearer ${userToken}`,
              "Screen-Name": "/Load",
            },
          }
        );
        console.log("Fetched documents:", response.data);
        setDocuments(response.data.documents || []);
      } catch (err) {
        console.error("Error fetching PDFs:", err);
        setError("Error loading documents.");
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, [isOpen, transport?.id]);

  const getFullUrl = (url) => {
    if (!url) return null;
    // Se o URL começar com http, devolve direto. Senão, monta a URL absoluta
    if (url.startsWith('http')) return url;
    return `https://new.cajuu.app${url.startsWith('/') ? url : `/${url}`}`;
  };

  return (
    isOpen && (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      >
        <div className="bg-white rounded-lg p-8 w-1/3 shadow-lg">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-4">
            Select PDF Options
          </h2>

          <div className="space-y-4">
            <button
              onClick={() => onOpenPdfGatePassModal("gatepass")}
              className="flex items-center justify-between bg-orange-500 text-white py-3 px-6 rounded-lg shadow-md transition-transform transform hover:scale-105 w-full"
            >
              <div className="flex items-center">
                <FaRegFilePdf className="mr-3 text-2xl" />
                <span className="text-lg font-medium">
                  All Documents (Gatepass / Release / Others)
                </span>
              </div>
              <span className="text-sm bg-blue-800 py-1 px-3 rounded-full">PDF</span>
            </button>

            {loading && (
              <p className="text-gray-700 text-center">Loading documents...</p>
            )}

            {error && (
              <p className="text-red-500 text-center">{error}</p>
            )}

            {documents.length > 0 && (
              <div className="mt-4 space-y-2">
                {documents.map((doc, index) => {
                  const pdfUrl = getFullUrl(doc.url);
                  if (!pdfUrl) return null;

                  return (
                    <a
                      key={index}
                      href={pdfUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-between bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition"
                    >
                      <div className="flex items-center">
                        <FaRegFilePdf className="mr-2" />
                        <span>{doc.name || `Document ${index + 1}`}</span>
                      </div>
                      <span className="text-xs">View PDF</span>
                    </a>
                  );
                })}
              </div>
            )}

            {!loading && documents.length === 0 && !error && (
              <p className="text-gray-500 text-center">No documents available.</p>
            )}
          </div>

          <button
            onClick={onClose}
            className="mt-6 flex items-center justify-center bg-gray-600 text-white py-3 px-6 rounded-lg shadow-md hover:bg-gray-700 transition-transform transform hover:scale-105 w-full"
          >
            Close
          </button>
        </div>
      </div>
    )
  );
};

export default OptionsModal;
